import React from 'react'
import { Checkbox, FormControlLabel, Radio } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { CheckCircle, RadioButtonUnchecked } from '@material-ui/icons'

const useStyles = makeStyles(theme => ({
  root: {
    border: ({ checked }) =>
      `1px solid ${checked ? theme.palette.primary.main : theme.palette.grey[400]}`,
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(1),
    width: '210px',
  },
  checkedIcon: {
    color: theme.palette.primary.main,
  },
  icon: {
    color: theme.palette.grey[400],
  },
}))

const StyledRadio = props => {
  const classes = useStyles()

  return (
    <Radio
      className={classes.radio}
      disableRipple
      checkedIcon={<CheckCircle className={classes.checkedIcon} />}
      icon={<RadioButtonUnchecked className={classes.icon} />}
      {...props}
    />
  )
}

const StyledCheckbox = props => {
  const classes = useStyles()

  return (
    <Checkbox
      className={classes.checkbox}
      checkedIcon={<CheckCircle className={classes.checkedIcon} />}
      icon={<RadioButtonUnchecked className={classes.icon} />}
      color="primary"
      {...props}
    />
  )
}

const FormControlItem = props => {
  const { type, checked } = props
  const classes = useStyles({ checked })

  const control = type === 'radio' ? <StyledRadio {...props} /> : <StyledCheckbox {...props} />

  return <FormControlLabel className={classes.root} control={control} {...props} />
}

export default FormControlItem
